import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { HUBSPOT_UTK_STORAGE_KEY, HUBSPOT_UTM_STORAGE_KEYS } from './useHubSpotConversion'

// Renderless. Mounted once near the top of the Router & observes every
// client-side navigation: whenever a URL carries `?hutk=` or `?utm_*=` we
// persist it. This captures HubSpot attribution on any page landing, not just
// the checkout confirmation page, so it survives the Auth0 round-trip and the
// multi-step checkout journey where the params otherwise drop off the URL.
export function HubSpotAttributionCapture() {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const persist = (key: string, value: string | null) => {
      if (!value) return
      try {
        localStorage.setItem(key, value)
      } catch {
        // localStorage unavailable (private mode / quota) — submit-time falls
        // back to the hubspotutk cookie / Mixpanel cookie.
      }
    }

    persist(HUBSPOT_UTK_STORAGE_KEY, searchParams.get('hutk'))
    persist(HUBSPOT_UTM_STORAGE_KEYS.utm_source, searchParams.get('utm_source'))
    persist(HUBSPOT_UTM_STORAGE_KEYS.utm_medium, searchParams.get('utm_medium'))
    persist(HUBSPOT_UTM_STORAGE_KEYS.utm_campaign, searchParams.get('utm_campaign'))
  }, [searchParams])

  return null
}
